import React, { useRef } from 'react';
import './HScroll.css';
import { motion, useScroll, useTransform } from 'framer-motion';

import Data from '../../Content/InovationEx/InovationEx.json'



const HorizontalScoll = () => {
    const targetRef = useRef(null);

    const { scrollYProgress } = useScroll({ target: targetRef });

    const x = useTransform(scrollYProgress, [0, 1], ['47%', '-47%']); //['40%', '-40%']

    const data = Data as textAndBackground[];

    return (
        <div className='carousel' ref={targetRef}>
            <div className='contentContainer'>
                <motion.div className='images' style={{ x }}>
                    {data.map((item, index) => (
                        <motion.div 
                            className='imageItem'
                            key={index}
                            initial={{ opacity: 0, y: 150 }}
                            whileInView={{ opacity: 1, y: 0, shapeImageThreshold: 0.99 }}
                            transition={{ duration: 0.5, ease: 'easeOut' }}
                            style={{ backgroundColor: item.color }}
                        >
                            <p className="text">
                                {item.text}
                            </p>
                        </motion.div>
                    ))}
                </motion.div>
            </div>

        </div>
    );
};

export default HorizontalScoll;